
import { defineComponent, PropType } from 'vue';
import ButtonModel from '@/models/ButtonModel';

export default defineComponent({
	name: 'common-button',

	props: {
		button: {
			type: Object as PropType<ButtonModel>,
			required: true
		},
		leftIcon: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},

	emits: ['click'],

	methods: {
		emitClick() {
			this.$emit('click');
		}
	}
});
